import { BuyerItemUi } from '@/components/Buyer/BuyerDirectory/Table/BuyerUi';
import { BuyerResponse } from '@/data/api/model/buyers/BuyersDto';

export const buyerResponseToBuyerItemUi = (
  item: BuyerResponse
): BuyerItemUi => {
  return {
    id: item.business_id,
    businessName: item.business_name,
    buyerName: item.account_name,
    email: item.email,
    phone: item.phone,
    kam: item.kam_name,
    trusted: item.is_trusted_user,
  };
};
